<template>
  <header
    ref="headerRef"
    class="header header-fixed"
    :class="{ 'menu-opened': isSidebarOpen }"
  >
    <div class="container">
      <nav class="navbar navbar-expand-lg header-nav justify-between">
        <!-- Mobile Btns-->
        <div class="navbar-header">
          <a
            class="three-lines"
            id="mobile_btn"
            href="javascript:void(0);"
            @click="toggleSidebar"
          >
            <span class="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </a>
        </div>

        <!-- Logo -->
        <div class="logo-area me-3">
          <router-link to="/index-5" class="navbar-brand">
            <img
              src="@/assets/img/logo.ad0b8567.png"
              class="img-fluid logo-img"
              alt="Logo"
            />
          </router-link>
        </div>

        <!-- Main Nav -->
        <div class="main-menu-wrapper" :class="{ 'd-block': isSidebarOpen }">
          <div class="menu-header">
            <router-link to="/index-5" class="menu-logo">
              <img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo" />
            </router-link>
            <a
              id="menu_close"
              class="menu-close"
              href="javascript:void(0);"
              @click="closeSidebar"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>

          <ul class="main-nav text-white">
            <li><router-link to="/index-5">الرئيسية</router-link></li>
            <li><router-link to="/pages/about-us">من نحن </router-link></li>
            <li><router-link to="/blog/blog-details">الأخبار</router-link></li>
            <li><router-link to="/sell-car">بيع سيارتك</router-link></li>
            <!-- <li><router-link to="/open-dealer">افتح معرضك</router-link></li> -->
            <li>
              <a href="javascript:void(0);" @click="goToAllCars"
                >جميع السيارات</a
              >
            </li>
            <li><router-link to="/services">الخدمات</router-link></li>
            <li><router-link to="/favorite">المفضلة</router-link></li>

            <!-- login / register / logout (mobile) -->
            <template v-if="!auth.isLoggedIn">
              <li class="mobile-auth">
                <router-link
                  class="nav-link header-login"
                  to="/authentication/login"
                >
                  <span><i class="fa-regular fa-user"></i></span> تسجيل الدخول
                </router-link>
              </li>
              <li class="mobile-auth">
                <router-link
                  class="nav-link header-reg"
                  to="/authentication/register"
                >
                  <span><i class="fa-solid fa-lock"></i></span> إنشاء حساب
                </router-link>
              </li>
            </template>
            <template v-else>
              <li class="mobile-auth">
                <button
                  class="nav-link header-login btn btn-link text-white"
                  @click="logout"
                >
                  <span><i class="fa-solid fa-right-from-bracket"></i></span>
                  تسجيل خروج
                </button>
              </li>
            </template>
          </ul>
        </div>

        <!-- login / register / logout (computer) -->
        <ul class="nav header-navbar-rht">
          <template v-if="!auth.isLoggedIn">
            <li class="nav-item">
              <router-link
                class="nav-link header-login"
                to="/authentication/login"
              >
                <span><i class="fa-regular fa-user"></i></span>تسجيل الدخول
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link header-reg"
                to="/authentication/register"
              >
                <span><i class="fa-solid fa-lock"></i></span>إنشاء حساب
              </router-link>
            </li>
          </template>
          <template v-else>
            <li class="nav-item">
              <button
                class="nav-link header-login btn btn-link text-white"
                @click="logout"
              >
                <span><i class="fa-solid fa-right-from-bracket"></i></span>
                تسجيل خروج
              </button>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useCarsStore } from "@/stores/cars-store";
import { useRouter } from "vue-router";

export default {
  setup() {
    const auth = useAuthStore();
    const isSidebarOpen = ref(false);
    const headerRef = ref(null);
    const carsStore = useCarsStore();
    const router = useRouter();
    // logout
    const logout = async () => {
      await auth.logOut();
    };

    // Sidebar control
    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
    };

    const closeSidebar = () => {
      isSidebarOpen.value = false;
    };

    const goToAllCars = () => {
      carsStore.resetFilters(); // Reset Filters
      carsStore.fetchCars();
      router.push("/listing/listing-grid");
    };

    // Scroll
    const onWindowScroll = () => {
      if (!headerRef.value) return;
      if (window.pageYOffset > 50) {
        headerRef.value.classList.add("scrolled");
      } else {
        headerRef.value.classList.remove("scrolled");
      }
    };

    // active un active scroll
    onMounted(() => {
      window.addEventListener("scroll", onWindowScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", onWindowScroll);
    });

    return {
      auth,
      logout,
      isSidebarOpen,
      toggleSidebar,
      closeSidebar,
      headerRef,
      goToAllCars,
    };
  },
};
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 1rem 0;
  background-color: transparent;
  box-shadow: none !important;
  transition: background-color 0.4s ease;
}
.header.scrolled {
  background-color: #000 !important;
}
.navbar-nav li a,
.main-nav li a {
  color: white !important;
  font-weight: bold;
  padding: 8px 10px;
  margin: 0 4px;
  display: inline-block;
  white-space: nowrap;
}
.navbar-nav li a {
  max-width: 80px !important;
}

.navbar-nav li a:hover,
.main-nav li a:hover {
  color: yellow !important;
}
.main-nav li .router-link-active {
  color: yellow !important;
}

.menu-header {
  display: none;
}
.mobile-auth {
  display: none !important;
}

@media (max-width: 991px) {
  .main-menu-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    width: 300px;
    height: 100vh;
    /* background-color: #04754e; */
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1000;
  }

  .menu-opened .main-menu-wrapper {
    transform: translateX(0);
  }

  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
  }

  .main-nav {
    flex-direction: column;
    /* padding: 1rem; */
  }
  .three-lines {
    margin-top: 70px;
    /* margin-left: 80px; */
  }
  .header.scrolled {
    background-color: white !important;
  }
  .mobile-auth {
    display: flex !important;
  }
}
.header .main-menu-wrapper .main-nav > li {
  margin-left: 1px !important;
}

.logo-img {
  height: 40px;
  max-width: 100%;
}
.logo-area {
  /* background-color: red; */
  max-width: 100px;
}
button.nav-link.header-login:hover {
  color: black !important;
}
</style>
